import { call, put, takeLatest } from 'redux-saga/effects'
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'

import * as saleConstant from './constants'
import * as saleAction from './actions'
import { transfersFromCached } from '../../../lib/common'

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}

function nvkdRequestApi(formData) {
  const request = axiosApi().post(
    saleConstant.SALE_REPORT_NVKD_API,
    formData
  )

  return handleRequest(request);
}
function* saleReportNvkdRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(nvkdRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(saleAction.saleReportNvkdSuccess(results.data))

  } catch (error) {
    yield put(saleAction.saleReportNvkdError(error))
  }
}
function khRequestApi(formData) {
  const request = axiosApi().post(
    saleConstant.SALE_REPORT_KH_API,
    formData
  )

  return handleRequest(request);
}
function* saleReportKhRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const { data } = yield call(khRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(saleAction.saleReportKhSuccess(transfersFromCached(data)))

  } catch (error) {
    yield put(saleAction.saleReportKhError(error))
  }
}
function listRequestApi(formData) {
  const request = axiosApi().post(
    saleConstant.SALE_REPORT_LIST_API,
    formData
  )

  return handleRequest(request);
}


function* saleReportListRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(listRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(saleAction.saleReportListSuccess(results.data))

  } catch (error) {
    yield put(saleAction.saleReportListError(error))
  }
}
function exportXlsRequestApi(formData) {
  const url = saleConstant.SALE_REPORT_EXPORT_XLS_API + "?s=" + formData.store_id + "&st=" + formData.tu_ngay + "&ed=" + formData.den_ngay
    + "&ldh=" + formData.loaiDonHang + "&ql=" + formData.treeQL + "&kd=" + formData.listNvkd
    + "&nkh=" + formData.listNhomKh + "&kh=" + formData.listKH + "&tt=" + formData.trangThai + "&kw=" + formData.keyword;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}
function* reportExportXlsRequestFlow(action) {
  const { formData, callback } = action
  try {
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, formData)
    // dispatch the action with our widgets!
    yield put(saleAction.reportExportXlsSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(saleAction.reportExportXlsError(error))
  }
}
function* saleReportNhomKhRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const request = axiosApi().post(
      saleConstant.SALE_REPORT_NHOMKH_API,
      payload
    )
    const results = yield call(handleRequest, request)
    // dispatch the action with our widgets!
    yield put(saleAction.saleReportNhomKhSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(saleAction.saleReportNhomKhError(error))
  }
}
function* saleReportKhByNhomRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const request = axiosApi().post(
      saleConstant.SALE_REPORT_KH_BY_NHOM_API,
      payload
    )
    const results = yield call(handleRequest, request)
    // dispatch the action with our widgets!
    const data = transfersFromCached(results.data)
    yield put(saleAction.saleReportKhByNhomSuccess(data))
    if (typeof callback == 'function') {
      yield call(callback, data);
    }
  } catch (error) {
    yield put(saleAction.saleReportKhByNhomError(error))
  }
}
function* saleReportWatcher() {
  yield [
    takeLatest(saleConstant.SALE_REPORT_NVKD_REQUESTING, saleReportNvkdRequestFlow),
    takeLatest(saleConstant.SALE_REPORT_KH_REQUESTING, saleReportKhRequestFlow),
    takeLatest(saleConstant.SALE_REPORT_LIST_REQUESTING, saleReportListRequestFlow),
    takeLatest(saleConstant.SALE_REPORT_EXPORT_XLS_REQUESTING, reportExportXlsRequestFlow),
    takeLatest(saleConstant.SALE_REPORT_NHOMKH_REQUESTING, saleReportNhomKhRequestFlow),
    takeLatest(saleConstant.SALE_REPORT_KH_BY_NHOM_REQUESTING, saleReportKhByNhomRequestFlow),
  ]
}

export default saleReportWatcher



// WEBPACK FOOTER //
// ./src/views/Reports/SaleReport/sagas.js